import { useTranslation } from 'next-i18next'

import GemstoneProgress from '~/components/GemstoneProgress'

import { MathEssentialActivityStat } from '~/redux/apis/user-stats-api'
import ContainerHomGradientBorderHexagon from '~/components/Containers/ContainerHomGradientBorderHexagon'

interface Props {
  activity: MathEssentialActivityStat
  hideBorder: boolean
}

export default function QuizStat({ activity, hideBorder = false }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  const accuracy: number = Math.floor(activity?.accuracy || 0)
  const stars: number = Math.floor(activity?.stars || 0)

  return (
    <>
      <div className="flex justify-between items-center pt-3">
        <div className="space-x-2 flex items-center">
          <ContainerHomGradientBorderHexagon
            innerClassName="bg-orchid-dark w-7 h-7 text-white font-semibold flex justify-center items-center"
            noBorder
          >
            {activity.quizNo}
          </ContainerHomGradientBorderHexagon>
          <p className="font-semibold">
            {t('quiz')} {activity.quizNo}
          </p>
        </div>
        <div className={`flex items-center pl-${stars > 0 ? 5 : 2}`}>
          <GemstoneProgress innerClassName="flex" outlineColor="black" score={stars} />
        </div>
        <div>
          {accuracy}% {t('correct')}
        </div>
      </div>
      {!hideBorder && <div className="my-4 w-full h-0.5 bg-purple-light" />}
    </>
  )
}
